import React from 'react';
import { connect } from 'react-redux';
import { getSelectedReturn, getLineItemsOfSelectedReturn, getLoadingReturnId } from '../../../../selectors/tools';
import { getDecisionNodeAtPath } from '../../../../extractFromState';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import * as colors from 'components/common/colorConstants';
import { formatDateTime } from '../../../../util';
import Spinner from 'components/common/spinner';
import {
  LoadingHolder,
  ResultsColumn,
  ResultsColumnGrey,
  CheckBoxColumn,
  Checkbox,
  ResultRowOrders,
  ResultRowItems,
  ResultItemContainer,
} from './DTReturnsSearchResult.styles';

// TODO: Refactor to a functional component
export class DecisionTreeReturnsSearchResult extends React.Component {
  getValue(object, field) {
    return get(object, field);
  }

  isReturnSelected() {
    const { result, selectedReturn } = this.props;

    return this.getValue(result, 'returnId') === this.getValue(selectedReturn, 'returnId');
  }

  getCurrencyCode() {
    const { result } = this.props;

    return this.getValue(result, 'currency');
  }

  handleReturnCheckboxClick() {
    const { clickAction, result } = this.props;
    if (this.hasReturnBeenChecked()) {
      clickAction({});
    } else {
      clickAction(result);
    }
  }

  hasReturnBeenChecked() {
    return this.isReturnSelected() || this.showItemsLoading();
  }

  showItemsLoading() {
    const { loadingId, result, selectedReturn } = this.props;

    return loadingId === this.getValue(result, 'returnId') && loadingId !== this.getValue(selectedReturn, 'returnId');
  }

  generateItemLoadingSection() {
    const { resultList, index } = this.props;

    return (
      <LoadingHolder showUnderline={resultList.length !== index + 1}>
        <Spinner color={colors.lightGray19} />
      </LoadingHolder>
    );
  }

  generateLineItems() {
    const { decisionNode, lineItems, markAsOrder } = this.props;

    let items;

    if (!decisionNode) {
      return null;
    }

    if (!lineItems) {
      return null;
    }

    items = lineItems.map((item, key) => {
      const title = this.getValue(item, 'title');
      const sku = this.getValue(item, 'sku');
      const reason = this.getValue(item, 'reason');
      const returnedAt = this.getValue(item, 'returnedAt');

      return (
        <ResultRowItems key={key}>
          <ResultsColumn>{sku}</ResultsColumn>
          <ResultsColumnGrey>{title}</ResultsColumnGrey>
          <ResultsColumnGrey>{reason}</ResultsColumnGrey>
          <ResultsColumnGrey>{formatDateTime(returnedAt)}</ResultsColumnGrey>
        </ResultRowItems>
      );
    });

    return <ResultItemContainer markAsOrder={markAsOrder}>{items}</ResultItemContainer>;
  }

  render() {
    const { result } = this.props;

    return (
      <div>
        <ResultRowOrders checked={this.hasReturnBeenChecked()} markAsOrder={this.props.markAsOrder}>
          <CheckBoxColumn>
            <Checkbox
              type="checkbox"
              checked={this.hasReturnBeenChecked()}
              onChange={(e) => this.handleReturnCheckboxClick(e)}
            />
          </CheckBoxColumn>
          <ResultsColumn width="20%">
            <span>{this.getValue(result, 'returnId')}</span>
          </ResultsColumn>
          <ResultsColumn width="25%">{this.getValue(result, 'trackingNumber')}</ResultsColumn>
          <ResultsColumn width="15%">{this.getValue(result, 'status')}</ResultsColumn>
          <ResultsColumn width="20%">{this.getValue(result, 'carrier')}</ResultsColumn>
          <ResultsColumn width="20%">{formatDateTime(this.getValue(result, 'createdAt'))}</ResultsColumn>
        </ResultRowOrders>
        {this.isReturnSelected() && this.generateLineItems()}
        {this.showItemsLoading() && this.generateItemLoadingSection()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedReturn: getSelectedReturn(state),
  loadingId: getLoadingReturnId(state),
  lineItems: getLineItemsOfSelectedReturn(state),
  decisionNode: getDecisionNodeAtPath(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DecisionTreeReturnsSearchResult);
